var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dataAnalysisManagement-page"},[_c('div',{staticClass:"all-content-container-ad"},[_c('div',{staticClass:"map-ad",attrs:{"id":"container"}})])])
}]

export { render, staticRenderFns }